import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UltimatePage from "./pages/UltimatePage";
import AdminDashboard from "./pages/AdminDashboard";
import PaidLeadsPage from "./pages/PaidLeadsPage";
import AdminGate from "./pages/AdminGate";
import ReportPage from "./pages/ReportPage";
import PaymentPage from "./pages/PaymentPage";
import ThankYouPage from "./pages/ThankYouPage";
import SubmittedPage from "./pages/SubmittedPage";
import ConsultationPage from "./pages/ConsultationPage";
import PrivacyPage from "./pages/PrivacyPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<UltimatePage />} />
          <Route path="/maliha-gupt-dwar-J2ipm3nqQUoUxrmse-rziroFzhFbeWTFeDkX-M6reQY" element={<AdminGate><AdminDashboard /></AdminGate>} />
          <Route path="/maliha-gupt-dwar-J2ipm3nqQUoUxrmse-rziroFzhFbeWTFeDkX-M6reQY/paid" element={<AdminGate><PaidLeadsPage /></AdminGate>} />
          <Route path="/report/:leadId" element={<ReportPage />} />
          <Route path="/submitted/:leadId" element={<SubmittedPage />} />
          <Route path="/consultation" element={<ConsultationPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/payment/:leadId" element={<PaymentPage />} />
          <Route path="/thank-you/:leadId" element={<ThankYouPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
